import Grid from 'atoms/Layout/Grid/Grid';
import Stack from 'atoms/Layout/Stack/Stack';
import { navigate } from 'gatsby';
import HeadingAndSupportingText from 'molecules/HeadingAndSupportingText/HeadingAndSupportingText';
import SpinnerLoading from 'molecules/SpinnerLoading/SpinnerLoading';
import React, { useEffect } from 'react';

const REDIRECT_TIMER_IN_MILLISECONDS = 5000;

const ThankYouMessage = (): JSX.Element => {
  useEffect(() => {
    const timeout = setTimeout(() => {
      // Redirect to the masterclass page
      navigate('/peoplemagic/masterclass');
    }, REDIRECT_TIMER_IN_MILLISECONDS);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <Grid totalColumns={1}>
      <Stack
        direction='column'
        gap='spacing-2xl'
        margin={['spacing-none', 'spacing-auto']}
      >
        <HeadingAndSupportingText
          heading={{
            text: 'You’re IN 🙌',
            type: 'heading',
            size: 'md',
          }}
          supportingText={{
            text: `We’re redirecting you now to give you INSTANT ACCESS to People Magic Profit. ${`\n\n`} You’ll ALSO get an email link in your inbox. You’re going to want to get back to this gold 🔑`,
            type: 'paragraph',
            size: 'md',
            whiteSpace: 'pre-line',
          }}
        />
        <SpinnerLoading width={24} />
      </Stack>
    </Grid>
  );
};

export default ThankYouMessage;
